{
  "vitalsEntry": {
    "title": "สัญญาณชีพ",
    "subtitle": "บันทึกและทบทวนสัญญาณชีพ",
    "printLabel": "พิมพ์สัญญาณชีพ",
    "recordSection": "บันทึกสัญญาณชีพ",
    "save": "บันทึกสัญญาณชีพ",
    "cancel": "ยกเลิก",
    "saving": "กำลังบันทึก...",
    "recordedSuccess": "บันทึกสัญญาณชีพสำเร็จ",
    "recordedError": "บันทึกสัญญาณชีพไม่สำเร็จ",
    "invalidEncounter": "รหัสการรับบริการไม่ถูกต้อง",
    "historyTitle": "สัญญาณชีพล่าสุด",
    "loadingHistory": "กำลังโหลดสัญญาณชีพ...",
    "loadError": "โหลดสัญญาณชีพไม่สำเร็จ",
    "emptyHistory": "ยังไม่มีการบันทึกสัญญาณชีพสำหรับการรับบริการนี้",
    "morseTitle": "แบบประเมินความเสี่ยงต่อการพลัดตกหกล้ม Morse",
    "bradenTitle": "แบบประเมินความเสี่ยงต่อแผลกดทับ Braden",
    "riskScalesSaved": "บันทึกคะแนนความเสี่ยงสำเร็จ",
    "riskScalesFailed": "บันทึกสัญญาณชีพแล้ว แต่บันทึกคะแนนความเสี่ยงไม่สำเร็จ"
  },
  "vitals": {
    "systolic": "ความดันซิสโตลิก",
    "diastolic": "ความดันไดแอสโตลิก",
    "heartRate": "อัตราการเต้นของหัวใจ",
    "respiratoryRate": "อัตราการหายใจ",
    "temperature": "อุณหภูมิ",
    "oxygenSaturation": "ค่าออกซิเจนในเลือด (SpO2)",
    "oxygenSaturationShort": "SpO2",
    "painScore": "คะแนนความปวด",
    "weight": "น้ำหนัก",
    "height": "ส่วนสูง",
    "bmi": "BMI",
    "rangeError": "{{field}} ต้องอยู่ระหว่าง {{min}} ถึง {{max}}",
    "placeholders": {
      "temperature": "เช่น 37.0",
      "heartRate": "เช่น 72",
      "respiratoryRate": "เช่น 16",
      "oxygenSaturation": "เช่น 98",
      "systolic": "เช่น 120",
      "diastolic": "เช่น 80",
      "weight": "เช่น 70.5",
      "height": "เช่น 175",
      "painScore": "0-10"
    }
  },
  "vitalsRange": {
    "normal": "ปกติ",
    "borderline": "ค่ากึ่งกลาง",
    "abnormal": "ผิดปกติ",
    "critical": "วิกฤต"
  },
  "tableHeaders": {
    "dateTime": "วันที่/เวลา",
    "temperature": "อุณหภูมิ",
    "heartRate": "ชีพจร",
    "respiratoryRate": "หายใจ",
    "bloodPressure": "ความดัน",
    "oxygenSaturation": "SpO2",
    "weight": "น้ำหนัก",
    "height": "ส่วนสูง",
    "pain": "ความปวด"
  },
  "io": {
    "title": "ปริมาณรับเข้า / ขับออก",
    "addRecord": "เพิ่มบันทึก",
    "addRecordSection": "เพิ่มบันทึกรับเข้า/ขับออก",
    "loading": "กำลังโหลดบันทึกรับเข้า/ขับออก...",
    "loadError": "โหลดบันทึกรับเข้า/ขับออกไม่สำเร็จ",
    "empty": "ยังไม่มีบันทึกรับเข้า/ขับออกสำหรับการรับบริการนี้",
    "totals": {
      "intake": "รับเข้ารวม",
      "output": "ขับออกรวม",
      "balance": "สมดุลสุทธิ",
      "totalsRow": "รวม",
      "netLabel": "สุทธิ"
    },
    "negativeWarning": "สมดุลติดลบ — โปรดประเมินภาวะสารน้ำ",
    "columns": {
      "dateTime": "วันที่/เวลา",
      "type": "ประเภท",
      "category": "หมวดหมู่",
      "amount": "ปริมาณ (ml)",
      "notes": "หมายเหตุ"
    },
    "fields": {
      "type": "ประเภท",
      "category": "หมวดหมู่",
      "amount": "ปริมาณ (ml)",
      "notes": "หมายเหตุ"
    },
    "type": {
      "intake": "รับเข้า",
      "output": "ขับออก"
    },
    "categoryPlaceholder": "เลือกหมวดหมู่...",
    "amountPlaceholder": "0",
    "notesPlaceholder": "หมายเหตุเพิ่มเติม...",
    "save": "บันทึก",
    "cancel": "ยกเลิก",
    "missingValueShort": "--",
    "toast": {
      "added": "เพิ่มบันทึกรับเข้า/ขับออกแล้ว",
      "addFailed": "เพิ่มบันทึกรับเข้า/ขับออกไม่สำเร็จ",
      "missingFields": "โปรดกรอกข้อมูลที่จำเป็น"
    }
  },
  "intake": {
    "oral": "ทางปาก",
    "iv": "IV",
    "bloodProducts": "ผลิตภัณฑ์เลือด",
    "tpn": "TPN",
    "tubeFeeding": "อาหารทางสายยาง",
    "other": "อื่น ๆ"
  },
  "output": {
    "urine": "ปัสสาวะ",
    "drain": "ท่อระบาย",
    "emesis": "อาเจียน",
    "stool": "อุจจาระ",
    "bloodLoss": "การเสียเลือด",
    "ngSuction": "ดูด NG",
    "other": "อื่น ๆ"
  },
  "wound": {
    "title": "บันทึกการดูแลแผล",
    "subtitle": "การรับบริการ #{{id}} — การประเมินแผลแบบโครงสร้าง",
    "newAssessment": "ประเมินแผลใหม่",
    "dimensionsTitle": "ขนาด (ซม.)",
    "woundBedTitle": "พื้นแผล (%)",
    "woundBedTotalWarning": "รวม: {{total}}% (ควรเป็น 100%)",
    "woundBedTotalOk": "รวม: 100%",
    "previousTitle": "การประเมินก่อนหน้า",
    "empty": "ยังไม่มีการประเมินแผลสำหรับการรับบริการนี้",
    "invalidEncounter": "รหัสการรับบริการไม่ถูกต้อง",
    "save": "บันทึกการประเมิน",
    "savedSuccess": "บันทึกการประเมินแผลแล้ว",
    "savedError": "บันทึกการประเมินแผลไม่สำเร็จ",
    "fields": {
      "woundType": "ประเภทแผล",
      "location": "ตำแหน่ง",
      "stage": "ระยะ",
      "length": "ยาว",
      "width": "กว้าง",
      "depth": "ลึก",
      "granulation": "เนื้อเยื่อแกรนูเลชัน",
      "slough": "เนื้อตายอ่อน (Slough)",
      "eschar": "สะเก็ดเนื้อตาย (Eschar)",
      "epithelial": "เยื่อบุผิว",
      "drainageType": "ชนิดสารคัดหลั่ง",
      "drainageAmount": "ปริมาณสารคัดหลั่ง",
      "surroundingSkin": "ผิวหนังโดยรอบ",
      "treatment": "การรักษาที่ใช้",
      "painScore": "คะแนนความปวด (0-10)",
      "notes": "หมายเหตุ"
    },
    "placeholders": {
      "length": "เช่น 3.5",
      "width": "เช่น 2.0",
      "depth": "เช่น 0.5",
      "treatment": "อธิบายการดูแลแผลที่ดำเนินการ...",
      "notes": "การสังเกตเพิ่มเติม..."
    },
    "history": {
      "dimensionsLabel": "ขนาด",
      "drainageLabel": "สารคัดหลั่ง",
      "painLabel": "ความปวด",
      "treatmentLabel": "การรักษา"
    },
    "stage": {
      "stage1": "ระยะ 1",
      "stage2": "ระยะ 2",
      "stage3": "ระยะ 3",
      "stage4": "ระยะ 4",
      "unstageable": "ระบุระยะไม่ได้",
      "deepTissue": "การบาดเจ็บของเนื้อเยื่อชั้นลึก",
      "na": "N/A"
    },
    "drainageType": {
      "none": "ไม่มี",
      "serous": "ใส",
      "sanguineous": "เลือด",
      "serosanguineous": "ใสปนเลือด",
      "purulent": "หนอง"
    },
    "drainageAmount": {
      "none": "ไม่มี",
      "scant": "น้อยมาก",
      "small": "น้อย",
      "moderate": "ปานกลาง",
      "large": "มาก",
      "copious": "มากมาย"
    },
    "woundType": {
      "pressure": "แผลกดทับ",
      "surgical": "แผลผ่าตัด",
      "diabetic": "แผลเบาหวาน",
      "venous": "แผลหลอดเลือดดำ",
      "arterial": "แผลหลอดเลือดแดง",
      "traumatic": "แผลจากอุบัติเหตุ",
      "skinTear": "ผิวหนังฉีกขาด",
      "other": "อื่นๆ"
    },
    "location": {
      "sacrum": "กระดูกกระเบนเหน็บ",
      "coccyx": "กระดูกก้นกบ",
      "leftHeel": "ส้นเท้าซ้าย",
      "rightHeel": "ส้นเท้าขวา",
      "leftTrochanter": "ปุ่มกระดูกต้นขาซ้าย",
      "rightTrochanter": "ปุ่มกระดูกต้นขาขวา",
      "abdomen": "หน้าท้อง",
      "leftLeg": "ขาซ้าย",
      "rightLeg": "ขาขวา",
      "back": "หลัง",
      "other": "อื่นๆ"
    },
    "surroundingSkin": {
      "intact": "ปกติ",
      "erythema": "ผื่นแดง",
      "macerated": "ผิวเปื่อย",
      "indurated": "ผิวแข็ง",
      "edematous": "บวม",
      "warm": "อุ่น",
      "discolored": "เปลี่ยนสี"
    }
  },
  "carePlan": {
    "title": "แผนการดูแล",
    "addPlan": "เพิ่มแผนการดูแล",
    "newPlan": "แผนการดูแลใหม่",
    "createPlan": "สร้างแผน",
    "cancel": "ยกเลิก",
    "empty": "ยังไม่มีแผนการดูแลสำหรับผู้ป่วยรายนี้",
    "emptyGoals": "ยังไม่ได้กำหนดเป้าหมาย",
    "goals": "เป้าหมาย",
    "addGoal": "เพิ่มเป้าหมาย",
    "saving": "กำลังบันทึก...",
    "loading": "กำลังโหลดแผนการดูแล...",
    "loadError": "โหลดแผนการดูแลไม่สำเร็จ",
    "fields": {
      "title": "ชื่อแผน",
      "startDate": "วันที่เริ่ม",
      "targetDate": "วันที่เป้าหมาย",
      "description": "รายละเอียด",
      "target": "เป้าหมาย"
    },
    "placeholders": {
      "title": "เช่น แผนป้องกันการพลัดตกหกล้ม",
      "description": "รายละเอียดเป้าหมาย",
      "target": "เช่น ไม่หกล้มภายใน 30 วัน"
    },
    "history": {
      "startLabel": "เริ่ม",
      "targetLabel": "เป้าหมาย",
      "goalsLabel": "เป้าหมาย"
    },
    "status": {
      "active": "กำลังดำเนินการ",
      "completed": "เสร็จสิ้น",
      "cancelled": "ยกเลิก"
    },
    "goalStatus": {
      "inProgress": "กำลังดำเนินการ",
      "achieved": "บรรลุแล้ว",
      "notAchieved": "ยังไม่บรรลุ"
    },
    "toast": {
      "planCreated": "สร้างแผนการดูแลแล้ว",
      "planCreateFailed": "สร้างแผนการดูแลไม่สำเร็จ",
      "goalAdded": "เพิ่มเป้าหมายแล้ว",
      "goalAddFailed": "เพิ่มเป้าหมายไม่สำเร็จ",
      "planValidation": "ชื่อแผนและวันที่เริ่มเป็นข้อมูลที่จำเป็น",
      "goalValidation": "รายละเอียดและเป้าหมายเป็นข้อมูลที่จำเป็น"
    }
  }
}
